<nz-spin [nzSpinning]="isLoading">
  <nz-card class="data-source-selection">
    <h3 class="nfl-form-label mb1" nz-typography>Select Data Source</h3>
    <nz-radio-group
      [(ngModel)]="selectedDatasourceModel"
      nzButtonStyle="solid"
      class="data-source-grid"
      (ngModelChange)="onDatasourceSelectionChange()"
    >
      <label
        class="data-source-card"
        [nzDisabled]="isDisabled(card)"
        *ngFor="let card of cardDetails"
        [nzValue]="card.key"
        nz-radio-button
        nz-tooltip
        [nzTooltipTitle]="card.tooltip"
      >
        <div class="label-content">
          <img [src]="card.imgSrc" [alt]="card.alt" />
          <div class="card-content">
            <h5 class="nfl-form-label mb0" nz-typography>{{ card.title }}</h5>
            <p class="nfl-form-label mb0" nz-typography>{{ card.description }}</p>
          </div>
        </div>
      </label>
    </nz-radio-group>
    <div class="action-buttons">
      <button nz-button nzType="primary" [disabled]="!selectedDatasourceModel" (click)="proceedCreateDatasource()">
        Proceed
      </button>
    </div>
  </nz-card>
</nz-spin>
